module.exports = "/static/assets/5ece8908fef739d9448eb27b957f463e.png";